import {useMemo} from 'react'

const Pagination = ({type, total, perPage, page, isLoading, onButtonClick}) => {

    const handleButtonClick = (element) => {
        switch (element.currentTarget.value) {
            case 'prev':
                onButtonClick(page - 1)
                break;
            case 'next':
                onButtonClick(page + 1)
                break;
            default:
                onButtonClick(parseInt(element.target.value))
        }

    }

    const handleLoadMoreClick = (element) => {
        onButtonClick(page + 1)

    }

    const pageCount = useMemo(() => Math.ceil(total / perPage), [total, perPage])

    const pageButtons = useMemo(() => {
        const buttons = []
        for (let i = 1; i <= pageCount; i++) {
            buttons.push(
                <li key={i} className={page === i ? 'page-item active' : 'page-item'}>
                    <button aria-label="page-number-button" className="page-link" onClick={handleButtonClick}
                            value={i}>{i}</button>
                </li>
            )
        }
        return buttons
    }, [pageCount, page])

    const pageDropdown = useMemo(() => {
        const options = []
        for (let i = 1; i <= pageCount; i++) {
            options.push(
                <option key={i} value={i}>{i}</option>
            )
        }
        return (
            <li className="page-select">
                <label htmlFor="blog-pagination">Page:</label>
                <select
                    name="pagination-select"
                    id="blog-pagination"
                    className="pagination-select"
                    datatype="blog"
                    value={page}
                    onChange={(e) => handleButtonClick(e)}
                >
                    {options}
                </select>
            </li>
        )
    }, [pageCount, page])


    if (type === 'load_more') {

        const loading_icon = isLoading ? "fa-circle-notch fa-spin" : "fa-plus-circle"

        return (
            <div className="load-more-wrapper text-center mt-5">
                {page < pageCount && (
                    <button id="react-blog-load-more" className="load-more-btn mb-0" onClick={handleLoadMoreClick}>
                        Load More <i id="react-blog-load-more-icon" className={"fal " + loading_icon}/>
                    </button>
                )}
            </div>
        );
    }

    return (
        <ul className="pagination">
            <li className={page <= 1 ? 'page-item disabled' : 'page-item'} data-disabled={page <= 1}>
                <button
                    aria-label="previous-page-button"
                    className="page-link"
                    onClick={page > 1 ? handleButtonClick : undefined}
                    value="prev"
                >
                    <i className="fal fa-angle-left"/>
                </button>
            </li>
            {total > 5 ? pageDropdown : pageButtons}
            <li className={page >= pageCount ? 'page-item disabled' : 'page-item'}
                data-disabled={page >= pageCount}>
                <button aria-label="next-page-button" className="page-link"
                        onClick={page < pageCount ? handleButtonClick : undefined} value="next">
                    <i className="fal fa-angle-right"/>
                </button>
            </li>
        </ul>
    )

}

export default Pagination